import { render, staticRenderFns } from "./VendorInventoryOtherVendors.vue?vue&type=template&id=7fd958d4"
import script from "./VendorInventoryOtherVendors.vue?vue&type=script&lang=js"
export * from "./VendorInventoryOtherVendors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports